// extracted by mini-css-extract-plugin
export default {"title":"PartnerCard_title__0CYBg","cardContainer":"PartnerCard_cardContainer__Oyako","card":"PartnerCard_card__-qJUA"};